import { Button, tokens, CompareNames } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import { ConfirmInfoTaskCard } from "components/molecules/ConfirmInfo/ConfirmInfoTaskCard";

const TitleTask = ({
  signingNames,
  titleNames,
  loading,
  onOpen,
}: {
  signingNames: string[];
  titleNames: string[];
  loading?: boolean;
  onOpen?: () => void;
}) => {
  return (
    <ConfirmInfoTaskCard
      taskHeader="1. Does the signing customer name match the name on the title?"
      taskAction={
        <Button
          onClick={onOpen}
          color="secondary"
          size="xs"
          style={{ height: "fit-content" }}
        >
          Edit
        </Button>
      }
      loading={loading}
    >
      <Row>
        <CompareNamesContainer>
          <CompareNames
            signingNames={signingNames}
            titleNames={titleNames}
            leftBackground={tokens.BRAND_OFF_GREY}
            rightBackground={tokens.CHARGEBLUE_80}
          />
        </CompareNamesContainer>
      </Row>
    </ConfirmInfoTaskCard>
  );
};

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const CompareNamesContainer = styled.div`
  min-width: 240px;
  width: 100%;
`;

export { TitleTask };
